/* eslint-disable eqeqeq */
import { useOrganizations } from '@/features/organizations';
import { Tooltip } from '@oncolens/oncolens-ui/lib/components/FormControls/Tooltip';
import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

interface IOrganizationSelectorDto {
  organizationIds: string[];
  assignAllOrganizations: boolean;
}

interface Props<T extends IOrganizationSelectorDto> {
  row: { original: T };
}

function OrganizationColumn<T extends IOrganizationSelectorDto>({
  row: { original: rowData },
}: Props<T>) {
  const { data: organizationData } = useOrganizations({
    pageSize: 500,
    options: {
      refetchOnMount: false,
      staleTime: Infinity,
    },
  });

  const orgCount = (rowData.organizationIds || 0) && rowData.organizationIds.length;
  const mappedOrgs = rowData.organizationIds
    ?.map((id) => organizationData?.data.find((org) => org.id === id)?.name)
    ?.sort();

  return (
    <>
      {rowData.organizationIds && rowData.organizationIds.length == 1 && (
        <p>
          {organizationData?.data?.find((x) => x.id === rowData.organizationIds[0])?.name ?? ''}
        </p>
      )}
      {orgCount > 1 && (
        <Tooltip
          text={mappedOrgs.map((name) => (
            <span className="block" key={name}>
              {name}
            </span>
          ))}
          icon={
            <p>
              <span className="flex items-center justify-center">
                {rowData.assignAllOrganizations ? 'All' : orgCount} Organizations{' '}
                <FaInfoCircle className="ml-1.5 text-blue-400" />
              </span>
            </p>
          }
        />
      )}
    </>
  );
}

export { OrganizationColumn as default };
